export const lightTheme = {
  component_header: '#FFF',
  text: '#363537',
  toggleBorder: '#FFF',
  background: '#363537',
};
export const darkTheme = {
  component_header: '#363537',
  text: '#FAFAFA',
  toggleBorder: '#6B8096',
  background: '#999',
};
